module.exports = __webpack_public_path__ + "static/img/vip.72c0266b.png";